<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Cadastrar Empresa'" :showBtn="true" :btnName="'Voltar'" :btnRoute="'/dashboard'"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->

            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="
                  col-xs-12 col-sm-12 col-md-12
                  default-box
                  filters
                  complete-filter
                ">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div>
                      <h2 class="titulo">Teste gratuitamente a MarQPonto</h2>
                      <h5>
                        A mais completa solução de ponto e gestão de RH para a
                        sua empresa.
                      </h5>
                    </div>
                    <form class="register-form">
                      <div class="col-xs-12 col-sm-6 col-md-6">
                        <div class="form-group">
                          <label for="name"></label>
                          <input type="text" name="name" id="name" placeholder="Nome da Empresa" class="form-control"
                                 v-model="dataRegister.name"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-6">
                        <div class="form-group">
                          <label for="phone"></label>
                          <input type="text" name="phone" id="phone" placeholder="Telefone" class="form-control"
                                 v-mask="['(##) ####-####', '(##) #####-####']" v-model="dataRegister.phone"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-6">
                        <div class="form-group">
                          <label for="email"></label>
                          <input type="email" name="email" id="email" placeholder="E-mail para acessar o sistema"
                                 class="form-control" v-model="dataRegister.email"/>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-6">
                        <div class="form-group">
                          <label for="password"></label>
                          <input type="text" name="password" id="password" placeholder="Senha para acessar o sistema"
                                 class="form-control" v-model="dataRegister.password"/>
                        </div>
                      </div>
                    </form>
                    <div class="col-md-12">
                      <div class="button-c">
                        <button class="ax-wid">
                          <span v-if="!loadingChange" v-on:click="createCompanyRegister()">Cadastrar</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  CREATE_COMPANY_REGISTER
} from "../../../../urlConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";

export default {
  name: "list-churns",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      loadingChange: false,
      dataRegister: {
        email: "",
        name: "",
        phone: "",
        password: "",
        isTesting: true,
      },
    };
  },
  methods: {
    createCompanyRegister() {
      this.loadingChange = true;

      UTIL_SERVICE.console("Data send:", this.dataRegister);
      REQUEST_SERVICE.requestContext(
        "POST",
        CREATE_COMPANY_REGISTER,
        this.$route.params.context,
        this.dataRegister
      )
        .then((response) => {
          UTIL_SERVICE.console(
            "RESULT CREATE_COMPANY_REGISTER:",
            response.data
          );

          this.dataRegister = response.data;
          this.loadingChange = false;
          swal("Aviso", "Empresa cadastrada com sucesso.", "success");
        })
        .catch((reason) => {
          this.loadingChangeAssign = false;

          swal({
            title: "Ops...",
            text: reason.response.data.erros[0].value,
            button: "Confirmar",
            icon: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.titulo {
  color: #352da5;
}

.complete-filter {
  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

  button {
    margin-top: 10px;
    width: 200px;
    padding: 0 20px;
    margin-left: 5px;
  }
}

.price-value {
  display: block;
  margin-bottom: 20px;
  font-weight: 600;
  text-transform: capitalize;
  color: #444d58;
  font-size: 16px;
  margin-left: 6px;
  margin-top: 0;

  span {
    color: #e7505a;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/RegisterCompany.vue